import countries from './countries.en';

export default
{
    form_title: 'Donate',
    form_back: 'Back to the videos',
    form_transfer: 'Bank transfer',
    form_description: 'You have the possibility to make a donation via credit card, Paypal, TWINT or bank transfer.',
    form_payment_text: 'Thanks for your donation!',
    amount: 'Amount',
    currency: 'Currency',
    gender: 'Title',
    gender_m: 'Mr',
    gender_f: 'Ms',
    firstname: 'First name',
    lastname: 'Last name',
    address: 'Address',
    email: 'Email',
    zip_code: 'Zip',
    city: 'City',
    country: 'Country',
    send: 'Send',
    once: 'One-time',
    monthly: 'Monthly',
    yearly: 'Yearly',
    countries
}